import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { xosoService } from "@/services/xosoService";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

export default function useStationResult(station, date) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!station || !date) return undefined;
    let cancelled = false;
    setLoading(true);
    setResults([]);

    (async () => {
      let data = await xosoService.getResultsByRegion(station, { date });
      const today = dayjs().tz(TZ).format("YYYY-MM-DD");
      if (!data.length && date === today) {
        data = await xosoService.getResultsByRegion(station, {});
      }
      if (!cancelled) {
        setResults(data);
        setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [station, date]);

  return { results, loading };
}
